import { render } from "./SocialsButtons.vue?vue&type=template&id=69afacf7&ts=true"
import script from "./SocialsButtons.vue?vue&type=script&lang=ts"
export * from "./SocialsButtons.vue?vue&type=script&lang=ts"

import "./SocialsButtons.vue?vue&type=style&index=0&id=69afacf7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__